import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { connectMediaStore, useMMSelector } from './withOwnReduxStore';
import { getGruser } from '../selectors';
export const useGruser = ()=>_object_spread({}, useMMSelector((state)=>({
            gruser: getGruser(state)
        })));
export default ((component)=>connectMediaStore((state)=>({
            gruser: getGruser(state)
        }))(component)); // redux is a bit dumb with generics
